export const API_DOMAIN = import.meta.env.VITE_API_DOMAIN || '';
